module.exports = __webpack_public_path__ + "img/08.50a061ab.jpg";